<div class="flex-1 mt-4">
  <div>
    <h2 class="mb-1" data-tour="chart-accounts-title">Map your owners</h2>
    <p class="mb-8 mt-0 text-night-lighter">
      Choose which owners to push to your accounting system and how to map them
    </p>
  </div>
  <div class="strong">{{ 'CORE.PRODUCT_NAME' | transloco }} Owner</div>
  <div *ngIf="eligibleOwners?.length" formGroupName="owners">
    <div class="flex flex-col w-full gap-2 pb-5">
      <div class="flex justify-between items-center w-full" *ngFor="let owner of eligibleOwners">
        <div class="text__small">{{ owner.label }}</div>
        <mat-form-field class="max-w-[300px] nopadding nomargin input__mini">
          <mat-select value="default" [formControlName]="owner.id">
            <mat-select-trigger>
              <div *ngIf="!form.form.get(['owners', owner.id]).value; else selectedEntityTpl">
                <span class="!text-night-lighter px-2 py-1 rounded-2xl bg-smoke-lighter text__xsmall">Default</span>
                Create new {{ getPlaceholder(owner.id) }}
              </div>
              <ng-template #selectedEntityTpl>
                <ng-container
                  *ngIf="(getDefaultValue$(owner.id) | async) === form.form.get(['owners', owner.id]).value">
                  <span class="!text-night-lighter px-2 py-1 rounded-2xl bg-smoke-lighter text__xsmall">Default</span>
                </ng-container>
                {{ (selectedEntity(owner.id) | async)?.name }}
              </ng-template>
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search
                [formControl]="getSearchControl(owner.id)"
                [placeholderLabel]="getSearchPlaceholder(owner.id)"
                noEntriesFoundLabel="No matching entity found"></ngx-mat-select-search>
            </mat-option>

            <mat-option value="" *ngIf="(getDefaultValue$(owner.id) | async) === null">
              <span class="!text-night-lighter px-2 py-1 rounded-2xl bg-smoke-lighter text__xsmall">Default</span>
              Create new {{ getPlaceholder(owner.id) }}
            </mat-option>

            <mat-option *ngFor="let entity of getAvailableOptions$(owner.id) | async" [value]="entity.id">
              <ng-container *ngIf="(getDefaultValue$(owner.id) | async) === entity.id">
                <span class="!text-night-lighter px-2 py-1 rounded-2xl bg-smoke-lighter text__xsmall">Default</span>
              </ng-container>
              {{ entity.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
